import { observer } from 'mobx-react'
import { FC } from 'react'
import GoodsDetailModal from '@/components/GoodsDetailModal/GoodsDetailModal'
import OpenVipModal from '@/components/OpenVipModal/OpenVipModal'
import PayModal from '@/components/PayModal/PayModal'
import CustomerServiceModal from '@/components/CustomerServiceModal/CustomerServiceModal'
import ExchangeCodeModal from '@/components/ExchangeCodeModal/ExchangeCodeModal'
import { ExchangeSuccessModal } from '@/components/ExchangeCodeModal/ExchangeCodeModal'
import LoginModal from '@/components/LoginModal/LoginModal'
import PaySuccessModal from '@/components/PaySuccessModal/PaySuccessModal'
import CustomMadeModal from '@/components/CustomMadeModal/CustomMadeModal'
import { uiController } from '@/controllers/uiController'
import { commonUtils } from '@/helpers/commonUtils'
import PayingPopup from '../mobile/PayingPopup/PayingPopup'
import PaySuccessPopup from '../mobile/PaySuccessPopup/PaySuccessPopup'

import ContactPopup from '../mobile/ContactPopup/ContactPopup'
import LoginDialog from '../mobile/LoginDialog/LoginDialog'
import CustomerEntry from '../mobile/CustomerEntry/CustomerEntry'
interface CommonDialogLayoutProps {}

const CommonDialogLayout: FC<CommonDialogLayoutProps> = observer(
  (props: CommonDialogLayoutProps) => {
    const isMobile = commonUtils.isMobile()
    if (isMobile) {
      return (
        <>
          <ContactPopup {...uiController.contactPopupProps} />
          <ContactPopup {...uiController.downloadConsultationQrCodePopupProps} />
          <CustomerEntry />
          <PaySuccessPopup {...uiController.paySuccessPopupProps} />
          <PayingPopup {...uiController.payingPopupProps} />
          <LoginDialog {...uiController.loginDialogProps} />
        </>
      )
    }
    return (
      <div>
        {uiController.goodsDetailModalProps.visible && (
          <GoodsDetailModal {...uiController.goodsDetailModalProps} />
        )}
        {uiController.openVipModalProps.visible && (
          <OpenVipModal {...uiController.openVipModalProps} />
        )}
        {uiController.payModalProps.visible && <PayModal {...uiController.payModalProps} />}
        {uiController.customerServiceModalProps.visible && (
          <CustomerServiceModal {...uiController.customerServiceModalProps} />
        )}
        {uiController.exchangeCodeModalProps.visible && (
          <ExchangeCodeModal {...uiController.exchangeCodeModalProps} />
        )}
        {uiController.exchangeSuccessModalProps.visible && (
          <ExchangeSuccessModal {...uiController.exchangeSuccessModalProps} />
        )}
        {uiController.loginModalProps.visible && <LoginModal {...uiController.loginModalProps} />}
        {uiController.paySuccessModalProps.visible && (
          <PaySuccessModal {...uiController.paySuccessModalProps} />
        )}
        {uiController.customMadeModalProps.visible && (
          <CustomMadeModal {...uiController.customMadeModalProps} />
        )}
      </div>
    )
  }
)

export default CommonDialogLayout
